import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-consistencycorner-hero-zoomcall.jpg`;
const ALT = "Lara laughing warmly at her desk during a video call, laptop screen showing a gallery of women joining the gathering.";

const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#e8463c] transition-colors";

export function ConsistencyCornerHero() {
  return (
    <section data-testid="cc-hero-section" className="relative overflow-hidden bg-[#FAFAF8]">
      {/* Full-bleed top band — preserves the whole composition (laptop + Zoom gallery + Lara) */}
      <div className="relative w-full overflow-hidden reveal aspect-[4/3.36] sm:aspect-[16/10.08] lg:aspect-[2/1.12]">
        <FadedImage
          src={IMG}
          alt={ALT}
          testId="cc-hero-image"
          bg="#FAFAF8"
          objectPosition="52% 35%"
          featherBottom={16}
          featherTop={6}
          className="absolute inset-0"
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-8 md:pt-10 pb-[52px] md:pb-[70px] reveal">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
            Consistency Corner
          </p>
          <h1
            data-testid="cc-hero-headline"
            className="font-display text-[36px] sm:text-[48px] lg:text-[58px] leading-[1.08] tracking-tight text-[#1C1917]"
          >
            Stay connected to what matters.
          </h1>
          <div className="mt-7 space-y-4 text-lg md:text-xl leading-relaxed text-[#57534E] max-w-[685px]">
            <p>You already know some of the things that matter most to you.</p>
            <p>The challenge isn&rsquo;t discovering them.</p>
            <p>
              It&rsquo;s continuing to make room for them after life gets busy,
              motivation fades or something more urgent asks for your attention.
            </p>
            <p>
              Consistency Corner is a gentle weekly gathering where you can
              pause, reconnect and take one honest step toward the life
              you&rsquo;re intentionally creating.
            </p>
          </div>
          <div className="mt-8">
            <a
              href="mailto:lara@blueprint4joy.com?subject=Consistency%20Corner"
              data-testid="cc-hero-cta"
              className={btnPrimary}
            >
              Join Consistency Corner
            </a>
          </div>
          <p className="mt-5 mb-[40px] text-base text-[#8A8580] italic">
            A weekly place to return to what matters.
          </p>
        </div>
      </div>
    </section>
  );
}
